module.exports = __webpack_public_path__ + "media/images/done-552a1edde03b2f061e7828023f33550c.svg";